<!-- Vertical layout -->
<ng-scrollbar style="height: calc(100vh - 49px)" visibility="hover" id="nav-ps-mantis">
  <div class="navbar-content">
    @if (isMenuReady) {
    <ul class="nav coded-inner-navbar" (clickOutside)="fireOutClick()" (mouseleave)="navMob()">
      @for (item of navigations; track item) {
        @if (item.type === 'group') {
          <app-nav-group [item]="item"></app-nav-group>
        }
      }
    </ul>
  }@else {
  <!-- Skeleton Loader -->
  <div class="nav-loading px-4 py-5 text-center">
    <div class="skeleton skeleton-avatar mb-3"></div>
    <div class="skeleton skeleton-line w-75 mx-auto mb-2"></div>
    <div class="skeleton skeleton-line w-50 mx-auto mb-4"></div>
    <div class="skeleton skeleton-box w-100 mb-3"></div>
    <div class="skeleton skeleton-box w-100 mb-3"></div>
    <div class="skeleton skeleton-box w-100 mb-3"></div>
    <div class="text-muted small mt-3">Cargando menú...</div>
  </div>
}
    <div class="m-4 mb-0">
      <div class="card nav-card">
        <div class="card-body">
          <div class="d-flex flex-column align-items-center">
            <img src="assets/images/idiomas.gif" alt="user" class="img-fluid" />
            <div class="m-t-20 text-center">
              <h5 class="mb-0">Scapa </h5>
              <span class="text-muted">Idiomas</span>
            </div>
            <!-- <div class="m-t-20 text-center">
              <a
                href="https://scapaidiomas.com"
                target="_blank"
                class="btn btn-primary text-white"
              >
            Scapa Idiomas
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-scrollbar>
